import create from "zustand";
import { db } from "../../../../config/firebase.config";
import { toast } from "react-toastify";
import { config } from "../alerts/index";
import {
  collection,
  addDoc,
  setDoc,
  getDoc,
  serverTimestamp,
  getDocs,
  deleteDoc,
  doc,
  query,
  updateDoc,
} from "firebase/firestore";
export const useStore = create((set, get) => ({
  reviews: [],
  mergedReviews: [],
  wishlists: [],
  averageRating: 0,
  selectedReview: null,
  averageReviewCount: 0,
  getAllReviews: async () => {
    try {
      let arr = [];
      const querySnapshot = await getDocs(collection(db, "reviews"));
      querySnapshot.forEach((doc) => {
        arr.push({ ...doc.data() });
      });
      const reviewArr = arr.reduce((acc, cur) => {return [...acc, ...cur.reviews]}, [])
      set({ reviews: [...arr ], mergedReviews: [...reviewArr]});

    } catch (error) {
      console.error(error.message);
    }
  },
  // getAllReviews: async () => {
  //   try {
  //     const querySnapshot = await getDocs(collection(db, "reviews"));
  //     const arr = querySnapshot.docs.map((doc) => ({ ...doc.data() }));
  //     const reviewArr = arr.reduce((acc, cur) => {return [...acc, ...cur.reviews]}, [])

  //     set({ reviews: reviewArr });
  
  //   } catch (error) {
  //     console.error(error.message);
  //   }
  // },

  getAllWishlists: async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "wishlists"));
      const wishlists = [];
      querySnapshot.forEach((doc) => {
        wishlists.push({ ...doc.data(), id: doc.id });
      });
      set({ wishlists });
      get({ wishlists });
    } catch (error) {
      console.error(error.message);
    }
  },
  deleteReview: async (id, email) => {

    try {
      const querySnapshot = await getDoc(doc(db, "reviews", id));
      
      const reviews = querySnapshot.data()

      await Promise.all(
        reviews.reviews.map((review, i) => {
          if (review.email == email) {
            reviews.reviews.splice(i, 1);
          }
        })
      );
      const newArr = reviews.reviews;
    
      const userRef = doc(db, "reviews", id);

      await updateDoc(
        userRef,
        {
          reviews: newArr,
        },
        { merge: true }
      );
      set({ reviews: newArr });
      get({ reviews: newArr });
      toast("Review deleted successfully", { ...config, type: "success" });
    } catch (error) {
      console.error(error.message, "Error deleting this review");
      toast("Error deleting this review", { ...config, type: "error" });
    }
  },
  reviewStatus: async (id, email) => {
    try {
      const querySnapshot = await getDoc(doc(db, "reviews", id));
      const reviews = querySnapshot.data();
      const newArr = reviews.reviews.map((review) => {
        if (review.email === email) {
          return {
            ...review,
            active: !review.active,
          };
        }
        return review;
      });

      const userRef = doc(db, "reviews", id);
      await updateDoc(
        userRef,
        {
          reviews: newArr,
        },
        { merge: true }
      );

      set({ reviews: newArr });
      get({ reviews: newArr });

      toast("Status has been changed", { ...config, type: "success" });
    } catch (error) {
      console.error(error.message);
      toast("Error changing the review status", { ...config, type: "error" });
    }
  },

  selelectedReview: (review) => {
    set({ selectedReview: review });
  },
}));
